// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Recruitment from "./pages/Recruitment";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import License from "./pages/License";
import ScrollToTop from "./components/ScrollToTop";
import FloatingWhatsAppButton from "./components/FloatingWhatsAppButton";
import BookCareModal from "./components/BookCareModal";
import JoinTeamModal from "./components/JoinTeamModal";

import { CareModalProvider } from "./context/CareModalContext";

function App() {
  return (
    <CareModalProvider>
      <Router>
        <ScrollToTop />
        <div className="app">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/recruitment" element={<Recruitment />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/license" element={<License />} />
            </Routes>
          </main>
          <Footer />

          <FloatingWhatsAppButton />
          <BookCareModal />
          <JoinTeamModal />
        </div>
      </Router>
    </CareModalProvider>
  );
}

export default App;
